export const validateMAC = (mac: string) => {
  const macRegex = /^([0-9A-Fa-f]{2}[:-\s\.]?){5}([0-9A-Fa-f]{2})$/;
  return macRegex.test(mac);
};
